import { useEffect, useState } from "react"
import { getFilterAlertTypeList } from "../services/alertGridServices";

export const useAlertType = () => {
  const [alertType, setAlertType] = useState([])
  const [alertTypeOptions, setAlertTypeOptions] = useState([]);

  useEffect(() => {
    getAlertType();
  }, []);

  const getAlertType = () => {
    let obj = {
      "type": "alertcode"
    }
    getFilterAlertTypeList(obj)
      .then((res) => {
        if (res.Status == "success") {
          setAlertType(res.Data);
          let arrTwo = res.Data.map((item) => ({
            value: item.AlertCodeId,
            label: item.AlertAssociated
          }))
          setAlertTypeOptions(arrTwo);
        }
      })
      .catch(err => console.log(err));
  }

  return { alertType, alertTypeOptions, setAlertType, setAlertTypeOptions, getAlertType }
}